module.exports = __webpack_public_path__ + "media/images/icon_popup_industry_sp_60-60-5f678edc8c82a78cb651741ce2d087df.png";